import { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import {
  unstable_useBlocker as useBlocker,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import BackButton from "../../../../../src/assets/images/back-button.svg";

import Button from "../ButtonComponent";

import FeedbackForm from "../FeedbackForm";

import { BUTTON_VARIANTS } from "../constant";

import { useGetPostMoudleFeedbackQuestionTypeKeys } from "./queries";

import { useSavePostModuleFeedback } from "./mutation";

import Shimmer from "../ShimmerComponent";

import { TYPE } from "./constant";

import styles from "./styles.module.scss";

import FeedbackRequiredModal from "../FeedbackRequiredModal";
import FeedbackComponent from "../FeedbackComponent";
import {
  ASSESSMENT_ALLOWED,
  LMS_COURSE_ID,
  LMS_COURSE_NAME,
  LMS_MODULE_ID,
  LMS_MODULE_NAME,
} from "../../../../utils/cookiesmanager";
import ModuleCertificateStatusModal from "../ModuleCertificateStatusModal";
import { useGetTranslatedText } from "../queries";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

const PostModuleFeedbackForm = () => {
  const [answered, setAnswered] = useState({});
  const [showMessage, setShowMessage] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const [allowLeave, setAllowLeave] = useState(false);
  const [thanksForFeedBack, setThanksForFeedback] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const timeoutRef = useRef(null);
  const module = TYPE.module;

  const navigate = useNavigate();

  const languageId = localStorage.getItem("l_id") || 1;

  const [searchParams] = useSearchParams();

  const courseId =
    searchParams.get("courseId") || localStorage.getItem(LMS_COURSE_ID);
  const moduleId =
    searchParams.get("moduleId") || localStorage.getItem(LMS_MODULE_ID);
  const moduleName = localStorage.getItem(LMS_MODULE_NAME);
  const courseName =
    searchParams.get("courseName") || localStorage.getItem(LMS_COURSE_NAME);

  const { data, isLoading , isFetching } = useGetPostMoudleFeedbackQuestionTypeKeys({
    module,
    languageId,
    courseId,
    moduleId
  });

  const languageid = localStorage.getItem("l_id") || 1;
  
  const {data:translatedTextResponse} = useGetTranslatedText(languageid)
            
  const {data:translatedText = []} = translatedTextResponse || {};

  const allQuestions = data?.response || [];

  const isAllAnswered = allQuestions.every(
    (q) => answered[q.assQuestionId] !== undefined,
  );

  const { mutate, isPending } = useSavePostModuleFeedback();

  const handleQuestionAnswer = (questionId, optionId) => {
    setAnswered((prev) => ({
      ...prev,
      [questionId]: optionId,
    }));
  };

  const handleGiveFeedBack = () => {
    setShowWarning(false);
  };

  const handleBackClick = () => {
    setShowWarning(true);
  };

  useEffect(() => {
    // Add a dummy history entry
    window.history.pushState(
      { guard: true },
      "",
      `${window.location.pathname}?${searchParams.toString()}`,
    );

    const handlePopState = () => {
      if (!allowLeave) {
        setShowWarning(true);

        // Re-push state to stop navigation
        window.history.pushState({ guard: true }, "", window.location.pathname);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [allowLeave]);

  const handleExit = () => {
    sessionStorage.removeItem(ASSESSMENT_ALLOWED);
    navigate(
      `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
      { state: { keepSidebarClosed: true } },
    );
  };

  const handleRedirection = () => {
    sessionStorage.removeItem(ASSESSMENT_ALLOWED);
    navigate(`/user/module-list?courseId=${courseId}&courseName=${courseName}`, {
      state: { keepSidebarClosed: true },
    });
  };

  const handleClick = () => {
    const questionArray = Object.entries(answered).map(([qId, aId]) => ({
      assQuestionID: String(qId),
      assAnswerID: String(aId),
    }));

    const payload = {
      courseId,
      moduleId,
      questionArray: questionArray,
    };

    mutate(payload, {
      onSuccess(data) {
        const { status, error } = data;

        if (!status) {
          throw new Error(error);
        }

        if (allowLeave) {
          setAllowLeave(true);
          setShowWarning(false);
          window.history.back();
          return;
        }
        // setShowMessage(true);
        setThanksForFeedback(true);
        // toast.success("Feedback submitted successfully");

        timeoutRef.current = setTimeout(() => {
          setThanksForFeedback(false);
          setShowCertificateModal(true);
        }, 2000);
      },
      onError(error) {
        setShowMessage(true);
        const serverMessage = error?.response?.data?.message;
        const finalMsg =
          serverMessage || error?.message || "Something went wrong";

         
        toast.error(finalMsg);
          setTimeout(() => {
           if(finalMsg === 'Please, First Complete the Module Assessment'){
            navigate(`/user/module-list?courseId=${courseId}&courseName=${courseName}`, {
              state: { keepSidebarClosed: true },
            });
          }
        }, 2000);
      },
    });
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
      const allowed = sessionStorage.getItem(ASSESSMENT_ALLOWED);
    
      if (!allowed) {
        navigate(
          `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
          { replace: true }
        );
      }
    }, []);

  return (
    <div className={styles["container"]}>
      <div className={styles["top-wrapper"]}>
        <div className={styles["icon-wrapper"]}>
          <img
            className={styles.icon}
            src={BackButton}
            alt="Icon"
            onClick={handleBackClick}
          />
        </div>

        <div className={styles["center-content"]}>
          <p className={styles.title}>{getTranslatedText(translatedText , "label_modules","Module")} {getTranslatedText(translatedText , "key_feedback","Feedback")}</p>
          <p className={styles.description}>{moduleName}</p>
        </div>
      </div>

      <div className={styles["container-top"]}>
        <div className={styles["container-wrapper"]}>
          {isLoading || isFetching ? (
            [...Array(3)].map((_, index) => (
              <Shimmer
                key={index}
                width="100%"
                height="190px"
                borderRadius="14px"
                style={{ marginBottom: "6px" }}
              />
            ))
          ) : (
            <FeedbackForm
              questionsList={allQuestions}
              handleQuestionAnswer={handleQuestionAnswer}
              answered={answered}
            />
          )}
        </div>
      </div>

      <div className={styles["bottom-wrapper"]}>
        <Button
          label={getTranslatedText(translatedText , "key_finish_share_feedback" , "Finish & Share Feedback")}
          buttonVariant={BUTTON_VARIANTS.PRIMARY}
          disabled={!isAllAnswered || isPending}
          className={styles["button-class"]}
          onClick={handleClick}
        />
      </div>
      {showWarning && (
        <FeedbackRequiredModal
          handleGiveFeedBack={handleGiveFeedBack}
          handleExit={handleExit}
          show={showWarning}
        />
      )}
      {thanksForFeedBack && (
        <FeedbackComponent
          show={thanksForFeedBack}
        />
      )}
      {showMessage && (
        <ToastContainer
          pauseOnHover={true}
          autoClose={2000}
          position="top-right"
        />
      )}
      {showCertificateModal && (
        <ModuleCertificateStatusModal
          show={showCertificateModal}
          handleRedirection={handleRedirection}
        />
      )}
    </div>
  );
};

export default PostModuleFeedbackForm;
